// Booking Success / Conversion Page
// Fires when customers complete online booking

import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

const BookingSuccess = () => {
  const [searchParams] = useSearchParams();
  const source = searchParams.get('source') || 'online_booking';
  const service = searchParams.get('service') || 'general';

  useEffect(() => {
    // Fire Google Ads conversion tracking (exact snippet)
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', 'conversion', {'send_to': 'AW-17180193668/94BoCOChwNkaEITnk4BA'});
    }

    // Page title handled by static generation
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Your plumbing service has been booked with Colorado First Plumbing. We\'ll contact you to confirm details and arrival time.');
    }

    // Add noindex meta tag for crawl budget protection
    const existingNoIndex = document.querySelector('meta[name="robots"]');
    if (!existingNoIndex) {
      const noIndexMeta = document.createElement('meta');
      noIndexMeta.name = 'robots';
      noIndexMeta.content = 'noindex, nofollow';
      document.head.appendChild(noIndexMeta);
    }
  }, [source, service]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-success-light to-neutral-light">
      <Header />
      
      <main className="pt-32 pb-16">
        <div className="container-custom text-center">
          <div className="max-w-2xl mx-auto bg-white rounded-xl shadow-xl p-8 border border-success-primary/20">
            {/* Success Icon */}
            <div className="w-20 h-20 bg-success-primary rounded-full flex items-center justify-center mx-auto mb-6">
              <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
              </svg>
            </div>
            
            {/* Booking Confirmed Message */}
            <h1 className="text-3xl md:text-4xl font-bold text-authority-navy mb-4">
              Booking Confirmed!
            </h1>
            
            <p className="text-xl text-authority-dark mb-6">
              Your plumbing service has been successfully booked. We'll contact you within <strong>1 hour</strong> to confirm details.
            </p>
            
            {/* Booking Details */}
            <div className="bg-success-light border border-success-primary/20 rounded-lg p-6 mb-6">
              <h3 className="font-bold text-success-primary mb-2">What Happens Next:</h3>
              <div className="space-y-2 text-left">
                <p className="text-authority-dark">
                  ✅ <strong>Confirmation Call:</strong> We'll call within 1 hour
                </p>
                <p className="text-authority-dark">
                  ✅ <strong>Service Details:</strong> Discuss your specific needs
                </p>
                <p className="text-authority-dark">
                  ✅ <strong>Arrival Time:</strong> Confirm convenient appointment time
                </p>
                <p className="text-authority-dark">
                  ✅ <strong>Transparent Pricing:</strong> No surprises, see costs before work begins
                </p>
              </div>
            </div>
            
            {/* Emergency Contact */}
            <div className="bg-action-urgent/10 border border-action-urgent/20 rounded-lg p-6 mb-6">
              <h3 className="font-bold text-action-urgent mb-2">Need Immediate Service?</h3>
              <div className="space-y-2">
                <p className="text-authority-dark">
                  <strong>24/7 Emergency Line:</strong>
                </p>
                
              </div>
            </div>
            
            {/* Navigation */}
            <div className="space-y-4">
              <a 
                href="/pricing" 
                className="inline-block bg-gradient-to-r from-trust-primary to-trust-deep text-white px-6 py-3 rounded-lg font-semibold hover:shadow-lg transition-all duration-300"
              >
                View Service Pricing
              </a>
              <br />
              <a 
                href="/" 
                className="text-authority-dark hover:text-trust-primary transition-colors"
              >
                ← Return to Homepage
              </a>
            </div>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default BookingSuccess;